import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import './Application-Form.css'



export default function ApplicationForm (){
    const formURL = 'https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=60b8a450-1984-4d50-90d1-cd7416a13ba5&env=na4&acct=c4911c48-8f4b-4910-848b-d4ec7431d966&v=2'


    return(

        <>
            <PageNameBanner pageName="Loan Application Form"/>
            <iframe src={formURL} className="docuSignForm"/>
        </>
    )
}
